export default function generateRandomPassword() {
  const ranges = [
    [65, 90], // Uppercase letters
    [97, 122], // Lowercase letters
    [48, 57], // Digits
    [35, 43], // Special characters type 1
    [58, 64] // Special characters type 2
  ];

  let result = '';
  for (let i = ranges.length - 1; i >= 0; i--) {
    const rangeIndex = Math.floor(Math.random() * ranges.length);
    const range = ranges.splice(rangeIndex, 1)[0];
    // Blacklist ambiguous characters
    const blackList = [',', '.', '\"', '\'', 'I', '1', 'i', 'l', '$'];
    let randomChar: string;
    do {
      randomChar = String.fromCharCode(Math.floor(range[0] + (range[1] - range[0] + 1) * (Math.random())));
    } while (blackList.includes(randomChar));
    result += randomChar;
  }
  for (let i = 9 - result.length; i >= 0; i--) {
    const range = (Math.random() > 0.5) ? [65, 90] : [97, 122];
    const randomChar = String.fromCharCode( Math.floor(range[0] + (range[1] - range[0]) * (Math.random())) );
    result = (Math.random() > 0.5) ? result + randomChar : randomChar + result;
  }
  return result;
}
